import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'cards-list-skeleton',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './cards-list-skeleton.component.html',
  styleUrl: './cards-list-skeleton.component.css'
})
export class CardsListSkeletonComponent {

}
